// extracted by mini-css-extract-plugin
export default {"header":"AddApartmentById_header__hgmou","icon":"AddApartmentById_icon__CXYiL"};